<template>
  <el-container>
    <el-header>
      <aui-header></aui-header>
    </el-header>
    <el-main class="login_container">
      <el-form :model="loginForm" ref="loginForm" :rules="rules" @keyup.enter="login">
        <el-form-item label="手机号" label-width="66px" prop="username">
          <el-input v-model="loginForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" label-width="66px" prop="password">
          <el-input v-model="loginForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label-width="0">
          <el-button type="primary" @click="login" size="medium" style="width: 98%;color: #FFFFFF;">登录</el-button>
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer>
      <aui-footer></aui-footer>
    </el-footer>
  </el-container>
</template>

<script>
import auiHeader from '../components/aui-header'
import auiFooter from '../components/aui-footer'
import shop from "./system/shop";

export default {
  name: "登录",
  components: {auiHeader, auiFooter},
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'change'
          }, {
            min: 6,
            message: '密码不小于6位',
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    login() {
      let isValid = true
      this.$refs['loginForm'].validate(valid => {
        if (!valid) {
          isValid = false
        }
      })
      if (!isValid) {
        this.$message.error('请输入手机号和密码')
        return
      }
      this.$apis.login.login(this.loginForm).then(response => {
        if (response.status === 200) {
          let user = response.data
          this.$utils.setStorage('token', user.token)
          if (response.data.type === 0) {
            this.$apis.shopMgr.get(response.data.sn).then(res => {
              let factory = res.data
              factory.expired = factory.factoryAuthEndTime == null || (new Date(factory.factoryAuthEndTime) - new Date()) / (3600000 * 24) <= 30
              this.$utils.setStorageObj('currentUser', factory)
              this.$router.push('/index')
            })
          } else {
            this.$utils.setStorageObj('currentUser', user)
            this.$router.push('/index')
          }
        }
      })
    }
  },
  created() {

  }
}
</script>

<style scoped>
.el-container {
  background: url('../assets/login-bg.jpg') no-repeat center;
  background-size: cover;
}

.login_container {
  height: 85vh;
}

.login_container form {
  margin: 16vh auto 0;
  padding: 28px 20px 8px;
  width: 400px;
  border-radius: 8px;
  background: #ffffff;
}

@media only screen and (max-width: 600px) {
  .login_container form {
    width: 88%;
  }
}
</style>
